const steps = [
  { num: "1", title: "Tell us about your practice", desc: "Share your basic details, website, and a few growth context points." },
  { num: "2", title: "We review the moving parts", desc: "Our team looks at the visible funnel, trust signals, and likely bottlenecks." },
  { num: "3", title: "You get a clear next-step picture", desc: "We send your checkup with priorities and recommended next actions." },
];

const CheckupHowItWorks = () => (
  <section id="how-it-works" className="py-14 md:py-20 bg-hero-bg">
    <div className="max-w-4xl mx-auto section-padding">
      <div className="text-center mb-10">
        <h2 className="text-2xl md:text-3xl font-bold text-hero-foreground tracking-tight">
          How It Works
        </h2>
      </div>

      <div className="grid md:grid-cols-3 gap-6 mb-8">
        {steps.map((s) => (
          <div key={s.num} className="text-center">
            <div className="w-10 h-10 rounded-full bg-accent text-accent-foreground flex items-center justify-center text-sm font-bold mx-auto mb-4">
              {s.num}
            </div>
            <p className="font-semibold text-hero-foreground mb-2">{s.title}</p>
            <p className="text-hero-foreground/50 text-sm leading-relaxed">{s.desc}</p>
          </div>
        ))}
      </div>

      <p className="text-center text-hero-foreground/40 text-xs">
        Most checkups are delivered within 3 business days, depending on queue volume and the complexity of the practice.
      </p>
    </div>
  </section>
);

export default CheckupHowItWorks;
